
class MapaBorderoFactory {
  makeDataGraficoMapaBordero(mapaBordero, isQtdProcessos, dataBase) {
    const mes = dataBase.split('/')[1];
    const ano = dataBase.split('/')[2];

    const data = [];
    if (!mapaBordero) {
      return data;
    }
    for (let i = 1; i <= 12; i += 1) {
      let mesAtual = parseInt(mes, 10) + (i);
      if (mesAtual > 12) {
        mesAtual -= 12;
      }
      if (mesAtual < 10) {
        mesAtual = `0${mesAtual}`;
      }

      let anoAtual = parseInt(ano, 10) - 1;
      if (parseInt(mes, 10) + (i) > 12) {
        anoAtual += 1;
      }

      let total = 0;
      let quantidade = 0;
      mapaBordero.forEach((item) => {
        total += item[`total${i}`] === null ? 0 : item[`total${i}`];
        quantidade += item[`quantidade${i}`];
      });

      data.push({
        data: `${mesAtual}/${anoAtual}`,
        item: isQtdProcessos ? quantidade : total,
      });
    }
    return data;
  }

  makeHeaderGraficoMapaBordero(mapaBordero, dataBase) {
    const mes = dataBase.split('/')[1];
    const ano = dataBase.split('/')[2];

    const data = [];
    if (!mapaBordero) {
      return data;
    }
    // A ordem foi invertida a pedido da task ABEW-3396
    for (let i = 12; i >= 1; i -= 1) {
      let mesAtual = parseInt(mes, 10) + (i);
      if (mesAtual > 12) {
        mesAtual -= 12;
      }
      if (mesAtual < 10) {
        mesAtual = `0${mesAtual}`;
      }

      let anoAtual = parseInt(ano, 10) - 1;
      if (parseInt(mes, 10) + (i) > 12) {
        anoAtual += 1;
      }

      data.push({
        data: `${mesAtual}/${anoAtual}`,
      });
    }
    return data;
  }
}

export const mapaBorderoFactory = new MapaBorderoFactory();
